/**
 * Utilities to handle layout adjustments between sidebar and main content
 */

// Function to adjust main content based on sidebar state
export function adjustMainContent(isCollapsed) {
    // Use requestAnimationFrame to avoid layout thrashing
    requestAnimationFrame(() => {
        // Select the main content element
        const mainContent = document.querySelector('.main-content');
        
        if (!mainContent) return;
        
        // Apply different styles based on sidebar state and screen size
        if (isCollapsed) {
            // When sidebar is collapsed, expand main content
            if (window.innerWidth < 768) {
                // Mobile view
                mainContent.style.paddingLeft = '5px';
            } else {
                // Desktop view
                mainContent.style.paddingLeft = '0';
            }
        } else {
            // When sidebar is expanded, reset padding
            if (window.innerWidth < 768) {
                mainContent.style.paddingLeft = '0';
            } else {
                mainContent.style.paddingLeft = '0';
            }
        }
    });
}

// Initialize layout adjustments
export function initLayoutHandling() {
    // Listen for sidebar toggling
    window.addEventListener('sidebarStateChange', (e) => {
        if (e.detail && typeof e.detail.isCollapsed !== 'undefined') {
            adjustMainContent(e.detail.isCollapsed);
        }
    });
    
    // Initial adjustment on page load
    window.addEventListener('DOMContentLoaded', () => {
        const sidebar = document.querySelector('[data-sidebar]');
        if (sidebar) {
            const isCollapsed = sidebar.classList.contains('sidebar-collapsed');
            adjustMainContent(isCollapsed);
        }
    });
    
    // Optimize resize event with throttling to avoid excessive calls
    let resizeTimeout;
    window.addEventListener('resize', () => {
        if (resizeTimeout) clearTimeout(resizeTimeout);
        
        resizeTimeout = setTimeout(() => {
            const sidebar = document.querySelector('[data-sidebar]');
            if (sidebar) {
                const isCollapsed = sidebar.classList.contains('sidebar-collapsed');
                adjustMainContent(isCollapsed);
            }
        }, 100); // Throttle to run at most once every 100ms
    });
}
